import { CustomError } from '@benzinga/templates';

import { RouteMeta } from './RouteMeta';

interface ErrorPageContentProps {
  statusCode: number;
}

export function ErrorPageContent({ statusCode }: ErrorPageContentProps) {
  return (
    <>
      <RouteMeta disablePageTracking />
      <CustomError statusCode={statusCode} />
    </>
  );
}
